// Template component

import { Component } from "@angular/core";

// Use block-ui-template class to center div if desired
@Component({
    template: `
    <div class="block-ui-template" id="please-wait-loader-container">
      <div id="please-wait-loader-wrapper">
          <div class="loader" id="please-wait-loader-spinner-wrapper">
              <img class="please-wait-loader-spinner" src="assets/images/loading-table.svg" />
          </div>
      </div>
    </div> 
    `,
  })
  export class BlockTemplateComponent {}